(() => {
  const darkModeQuery = window.matchMedia('(prefers-color-scheme: dark)');
  const applyTrustpilotTheme = (widget) => {
    if (widget.matches('.trustpilot-widget')) {
      if (darkModeQuery.matches) {
        widget.dataset.theme = 'light';
      } else {
        widget.removeAttribute('data-theme');
      }
    }
  };

  const setTrustpilotTheme = () => {
    document.querySelectorAll('.trustpilot-widget').forEach(applyTrustpilotTheme);
  };

  // Trustpilot reads this setting while its deferred bootstrap script creates the iframe.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setTrustpilotTheme, { once: true });
  } else {
    setTrustpilotTheme();
  }

  document.addEventListener('shopify:section:load', setTrustpilotTheme);
})();
